import * as React from 'react';

export interface IOfferLinkProps {
  link: string;
  onClick?(): void;
  className?: string;
}

export const OfferLink: React.FC<IOfferLinkProps> = props => {
  return (
    <a
      target="_blank"
      rel="nofollow noopener noreferrer"
      href={props.link}
      className={props.className}
      onClick={props.onClick}
    >
      {props.children}
    </a>
  );
};

OfferLink.displayName = 'OfferLink';
